import { createFileRoute } from '@tanstack/react-router'

import { Product } from '@/api/admin-products-types'
import { RouteModal } from '@/components/route-modal'
import { UnitOfMeasureForm } from '@/routes/_authenticated/_general/products/$productUuid/units/-form'

export const Route = createFileRoute('/_authenticated/_general/products/$productUuid/units/$unitUuid')({
	component: EditUnitOfMeasure
})

function EditUnitOfMeasure() {
	const { productUuid, unitUuid } = Route.useParams()

	return (
		<RouteModal
			prev='..'
			asDrawer
			requiresData
			loader={async api => await api.getProduct({ path: { productUuid } })}
		>
			{(product: Product) => {
				const unit = product.variants[0]?.unitsOfMeasure?.find(candidate => candidate.uuid === unitUuid)
				if (!unit || unit.isBase) {
					return null
				}
				return <UnitOfMeasureForm product={product} unit={unit} />
			}}
		</RouteModal>
	)
}
